import React, { useContext, useEffect, useState } from "react";
import { Layout, Form, Input, Button, Row, Col, Select, Pagination } from "antd";
import { toast } from "react-toastify";
import { GetGrantsFavorite, GetGrants } from "../../../../API/GrantsAPI";
import LinesCard from "../../../../Components/GrantsSeacher/LinesCard";
import CardHeader from "../../../components/CardHeader";
import Loader from "../../../../Components/Shared/Loader";
import useLoading from "../../../../Hooks/useLoading";
import { GrantsModel, GrantsModelResponse } from "../../../../Models/GrantsModel";
import { useLocation } from "react-router-dom";
import useCan from "../../../../Hooks/useCan";
import { ExternalRoles } from "../../../../Static/Roles";
import { CompanyContext } from "../../../../Contexts/CompanyContext";
import { ClearOutlined, SearchOutlined, HeartOutlined } from "@ant-design/icons";
import { AllStates } from "../../../../Utils/AllStates";
import { AllSectors } from "../../../../Utils/AllSectors";
import { AllBeneficiary } from "../../../../Utils/AllBeneficiaries";
import './styles.css';

const { Item } = Form;
const { Option } = Select;

export default function GrantsLines() {
    const canNotView = useCan({ rolesCan: ["Internal", ...ExternalRoles] });
    const { loading, toggleLoading } = useLoading();
    const { company } = useContext(CompanyContext);
    const { state } = useLocation();
    const [grants, setGrants] = useState<GrantsModelResponse[]>([]);
    const [showFavorites, setShowFavorites] = useState(state?.justFavorites || false);
    const externalUsers = useCan({rolesCan: [ "Master", "Technician", "Financial", "HumanResources"]})
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 8,
        total: 0,
    });

    const [form] = Form.useForm();
    interface GrantsReponse {
        data: {
            items?: GrantsModelResponse[];
            total?: number;
            length?: number;
        };
    }
    
    const getAllGrants = async (filters: any = {}) => {
        try {
            toggleLoading(true);
            let resp: GrantsReponse;
            if (showFavorites) {
                resp = await GetGrants(company.id, filters.SearchText || "", pagination.current);
                const items = resp.data.items || []
                const favoriteItem = items.filter(item => item.isFav);
                setGrants(favoriteItem);
                setPagination((prev) => ({ ...prev, total: resp.data?.length || 0 }));
            } else {
                resp = await GetGrants(company.id, filters.SearchText || "", pagination.current);
                setGrants(resp.data.items || []);
                setPagination((prev) => ({ ...prev, total: resp.data?.total || 0 }));
            }
        } catch (error: any) {
            toast.error(error.message || "Erro ao carregar as linhas.");
        } finally {
            toggleLoading(false);
        }
    };

    const handleToggleFav = () => {
        if(externalUsers){
            setShowFavorites(true)
        }else{
        setShowFavorites(!showFavorites);
        setPagination((prev) => ({ ...prev, current: 1 }));
        }
    };

    const handleSearch = (values: any) => {
        setPagination((prev) => ({ ...prev, current: 1 }));
        getAllGrants(values);
    };

    const clearForm = () => {
        form.resetFields();
        setPagination((prev) => ({ ...prev, current: 1 }));
        getAllGrants();
    };

    const handlePageChange = (page: number, pageSize?: number) => {
        setPagination({ ...pagination, current: page, pageSize: pageSize || 16 });
    };
    let description: string

    function descripctionLines(){
        
        if(externalUsers){
            description = "Exibir Linhas Favoritas"
        }else{
            if(showFavorites){
                description = "Exibir Todas"
            }else{
                description = "Exibir Linhas Favoritas"
            }
        }
      
        return description;
    }

    useEffect(() => {
        getAllGrants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showFavorites, pagination.current]);
    
    return (
        <Layout style={{ background: 'white', padding: '0 30px 30px', marginTop: '16px', borderRadius: '8px' }}>
            {loading && <Loader />}
            <CardHeader
                pageName={"Linhas"}
                hasPageBefore={false}
                pageBeforeName={"Buscador de Linhas"}
                isToHome={true}
                linkPageBefore={`/grantsSearcher/grants`}
            />
            <Form form={form} layout="vertical" onFinish={handleSearch}>
                <Row gutter={[16, 16]} align="middle">
                    <Col span={12}>
                        <Item label="Palavras Chaves" name="SearchText">
                            <Input placeholder="Digite as palavras-chaves ..." />
                        </Item>
                    </Col>
                    {!externalUsers && 
                    <Col span={4}>
                        <Button type="primary" htmlType="submit" style={{ borderRadius: '8px' }} block>
                            <SearchOutlined /> <span>Buscar</span>
                        </Button>
                    </Col>
                    }
                    <Col span={4}>
                        <Button onClick={clearForm} type="default" style={{ backgroundColor: '#D9D9D9', borderRadius: '8px' }} block>
                            <ClearOutlined /> <span>Limpar Filtros</span>
                        </Button>
                    </Col>
                    <Col span={4}>
                        <Button onClick={handleToggleFav} style={{ backgroundColor: '#00AEFF', borderRadius: '8px' }} block>
                            <HeartOutlined style={{ color: '#FFFFFF' }} />
                            <span style={{ color: '#FFFFFF' }}>
                                {descripctionLines()}
                            </span>
                        </Button>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} align="middle">
                    <Col span={12}>
                        <Item label="Setores" name="Sector">
                            <Select placeholder="Selecione um setor" options={AllSectors} allowClear />
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item label="Localizações" name="State">
                            <Select placeholder="Selecione uma localização" options={AllStates} allowClear />
                        </Item>
                    </Col>
                </Row>
                <Row gutter={[16, 16]} align="middle">
                    <Col span={12}>
                        <Item label="Status" name="Status">
                            <Select placeholder="Selecione um status" allowClear>
                                <Option value="Ativo">Ativo</Option>
                                <Option value="Desativado">Desativado</Option>
                            </Select>
                        </Item>
                    </Col>
                    <Col span={12}>
                        <Item label="Tipo de Beneficiário" name="BeneficiaryKind">
                            <Select placeholder="Selecione um tipo de beneficiário" options={AllBeneficiary} allowClear />
                        </Item>
                    </Col>
                </Row>
            </Form>
            <div className="title-with-line">
                <div className="line-divider"></div>
                <h3> Listagem de Linhas</h3>
                <div className="line-divider"></div>
            </div>
            <Row gutter={[32, 32]}>
                {grants && grants.map((grant, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                        <LinesCard
                            key={index} {...grant}
                            toggleLoading={toggleLoading}
                            canNotView={canNotView}
                            handleToggleFav={handleToggleFav}
                        />
                    </Col>
                ))}
            </Row>
            {!showFavorites && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Pagination
                        current={pagination.current}
                        total={pagination.total}
                        pageSize={pagination.pageSize}
                        onChange={handlePageChange}
                    />
                </div>
            )}
        </Layout>
    );
}